var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 101,
    viewBox: "0 0 87 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.1287 100.301L41.2689 97.821C21.664 71.242 9.1882 53.1093 3.60894 39.1612C-4.44998 19.0138 2.98904 9.71504 6.63106 6.69294C12.9077 1.34615 22.6714 1.03627 30.9628 5.99561C36.6195 9.40516 40.8815 16.0692 43.4387 22.8109C51.0326 4.44578 62.1911 -1.13345 70.6375 0.183879C79.6263 1.5012 85.9805 10.1026 86.058 21.1061C86.2905 45.2829 66.3756 70.6995 48.7854 93.094L43.1287 100.301ZM18.642 7.08039C15.2324 7.08039 12.0553 8.08776 9.65313 10.18C3.68642 15.2168 3.0665 25.1356 7.94835 37.379C13.2176 50.4747 24.8411 67.5999 43.2062 92.5516L45.0659 90.1495C61.3388 69.4597 81.5636 43.6556 81.3311 21.1061C81.2536 12.5048 76.5267 5.76307 69.9401 4.7557C62.7335 3.67084 51.9625 9.94755 45.3759 30.9473L42.6638 39.6261L40.8815 30.7148C39.4092 23.4307 34.9148 13.8221 28.4831 9.94757C25.306 8.08782 21.8965 7.08039 18.642 7.08039Z",
    fill: "#3CCFB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.4886613391e7f9f8105347f448dc1f07.svg";
export { ForwardRef as ReactComponent };